/**
 * kusbakisiYardimci.js - the company portal's ONE drawing (the Kuşbakışı = the Teknik Talep Planı) and the two places it is filed
 * (#696 follow-up, 2026-11-03). Pure helpers, no React, no services - tested in kusbakisiYardimci.test.js.
 *
 * The backend keeps two different slots for what the portal treats as one drawing:
 *   - 3-D Görseller (stand_file 2) > Kuşbakışı (sub 85): what the Talep Gönder gate (backend #695), the Elektrik taahhütname source and the
 *     staff taahhütname panel read;
 *   - Elektrik Planı (stand_file 3, no sub): a required document of the fair rules (belge_kural), which the portal calls "Teknik Talep Planı".
 * Before this, the portal filed the drawing only in slot 3, so Gönder never saw it. One upload now writes both (85 first), and every reader
 * takes the newest of either. When the fair rules stop requiring slot 3, drop it from planYazimlari().
 */
import { GORSEL_STAND_FILE_ID, KUSBAKISI_SUB_ID } from "./taahhutnameYardimci";

export { GORSEL_STAND_FILE_ID, KUSBAKISI_SUB_ID };
export const PLAN_STAND_FILE_ID = 3;

/**
 * The [standFileId, subStandFileId] pairs one upload of the drawing writes, in order. Live: Kuşbakışı first (the one Gönder needs, so a failure
 * there leaves nothing half written), then slot 3. Mock stands have no Kuşbakışı sub-file (their 3-D group is stand_file 5), so only slot 3.
 */
export function planYazimlari(live) {
  return live
    ? [[GORSEL_STAND_FILE_ID, KUSBAKISI_SUB_ID], [PLAN_STAND_FILE_ID, null]]
    : [[PLAN_STAND_FILE_ID, null]];
}

/** Is this uploaded file the drawing, in either of its two places? A deleted one never is. */
export function planDosyasiMi(f) {
  if (!f || f.deleted) return false;
  const standFileId = Number(f.standFileId);
  if (standFileId === PLAN_STAND_FILE_ID) return f.subStandFileId == null;
  return standFileId === GORSEL_STAND_FILE_ID && Number(f.subStandFileId) === KUSBAKISI_SUB_ID;
}

/** The newest drawing among a stand's uploaded files (null when there is none). */
export function planDosyasi(uploadedFiles) {
  const liste = (uploadedFiles || []).filter(planDosyasiMi);
  return liste.slice().sort((a, b) => new Date(b.uploadedAt ?? 0) - new Date(a.uploadedAt ?? 0))[0] ?? null;
}
